const LogOut = async () => {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    localStorage.removeItem("Token");
    localStorage.removeItem("Expire");
    localStorage.removeItem("LastLogin");
  }else{
    localStorage.clear();
  }
};
export default LogOut;
